@for (section of (initiativeTypesSections$ | async); track section; let sectionIndex = $index) {
<div class="grey-background ion-text-start section-parent-divider" (click)="toggleVisibility(sectionIndex)">
  <div class="initiative-type-section parent-color">
    <div style="cursor: pointer">
      @if (showSections[sectionIndex]) {
      <span class="icon-margin">(-)</span>
      } @if (!showSections[sectionIndex]) {
      <span class="icon-margin">(+)</span>
      }
      <span>{{ section.parent.name }}</span>
    </div>
  </div>
</div>

@if (showSections[sectionIndex]) {
<nb-list>
  @for (type of section.children; track type) {
  <nb-list-item (click)="selectInitiativeType(type)" class="child-section"
                style="cursor: pointer"
                [class.selected]="type.id === selectedTypeId">
    <span>
      @if (type.id === selectedTypeId) {
        <i class="fa-light fa-check icon-margin"></i>
      }
    </span>
    <span>
      <div>{{ type.setup_reference }}</div>
      <div class="action-type-name">{{ type.name }}</div>
    </span>
  </nb-list-item>
  }
</nb-list>
} }
